import Category from "./Category";

class Admin {
  id;
  name;
  email;
  phone;
  image;
  categoriesCreated;
  role;
  gender;

  constructor(data) {
    this.init(data);
  }

  // initialize the admin
  init(data) {
    const { id, role, name, email, phone, image, categories, gender } = data;

    if (!id || !name || !email || !phone || !image || role !== 1)
      throw new Error("Invalid admin data");

    const allCategoriesCreated = categories
      ? categories.map((category) => new Category(category))
      : [];

    this.id = id;
    this.role = role;
    this.name = name;
    this.email = email;
    this.phone = phone;
    this.image = image;
    this.gender = gender;
    this.categoriesCreated = [...allCategoriesCreated];
  }

  //somes getters
  get getId() {
    return this.id;
  }

  get getName() {
    return this.name;
  }

  get getEmail() {
    return this.email;
  }

  get getPhone() {
    return this.phone;
  }

  get getImage() {
    return this.image;
  }

  get getGender() {
    return this.gender;
  }

  /**
   * @returns Array of categories created by the admin
   */
  get getCategoriesCreated() {
    return this.categoriesCreated;
  }

  // some methods
  updateProfile(data) {
    const { name, email, phone, image } = data;
    this.name = name ? name : this.name;
    this.email = email ? email : this.email;
    this.phone = phone ? phone : this.phone;
    this.image = image ? image : this.image;
  }

  createCategory(data) {
    const { id, name, numberStars, image } = data;
    if (!id || !name || !numberStars || !image)
      throw new Error("Invalid category data");

    const category = new Category({ id, name, numberStars, image });
    this.categoriesCreated.push(category);
  }

  updateCategory(categoryId, data) {
    const category = this.categoriesCreated.find(
      (category) => category.id === categoryId
    );
    if (!category) throw new Error("Category not found");

    category.update(data);
  }

  deleteCategory(categoryId) {
    const category = this.categoriesCreated.find(
      (category) => category.id === categoryId
    );

    if (!category) throw new Error("Category not found");

    this.categoriesCreated = this.categoriesCreated.filter(
      (category) => category.id !== categoryId
    );
  }
}

export default Admin;
